<template>
<div class="page_adressAdd">
	<div class="adress_form">
        <div class="item">
            <div class="item_l">发票类型</div>
            <div class="item_r">
                <van-radio-group style="margin-left:10px" v-model="form.type" direction="horizontal">
                    <van-radio :name="1" checked-color="#d34444">电子发票</van-radio>
                    <van-radio :name="2" checked-color="#d34444">纸质发票</van-radio>
                </van-radio-group>
            </div>
        </div>
        <div class="e_invoice_attention" v-if="form.type==1">电子发票与纸质发票具有相同的法律效力，可以报销、售后、维权凭证，使用电子发票，不易丢失，更方便环保</div>
        <div class="item" v-if="form.type==2">
            <div class="item_l_i">发票类型</div>
            <div class="item_r">
                <van-field value="增值税专用发票" readonly />
            </div>
        </div>
        <div class="item" v-if="form.type==1">
            <div class="item_l">发票抬头</div>
            <div class="item_r">
                <van-radio-group style="margin-left:10px" v-model="form.nameType" direction="horizontal">
                    <van-radio :name="1" checked-color="#d34444">个人</van-radio>
                    <van-radio :name="2" checked-color="#d34444">企业</van-radio>
                </van-radio-group>
            </div>
        </div>
        <!-- 电子发票----个人 -->
        <div v-if="form.type==1&&form.nameType==1">
            <div class="item">
                <div class="item_l_i">抬头名称</div>
                <div class="item_r">
                    <van-field value="个人" readonly />
                </div>
            </div>
            <div class="item">
                <div class="item_l">手机号码</div>
                <div class="item_r">
                    <van-field v-model="form.tel" placeholder="请输入联系人手机号" />
                </div>
            </div>
        </div>
        <div v-if="form.type==2||(form.type==1&&form.nameType==2)">
            <div class="item">
                <div class="item_l">企业名称</div>
                <div class="item_r">
                    <van-field v-model="form.company" placeholder="请输入企业名称" />
                </div>
                <div class="item_r_select" @click="selectInvoiceAction">
                    请选择
                </div>
            </div>
            <div class="item">
                <div class="item_l">识别号</div>
                <div class="item_r">
                    <van-field v-model="form.shuihao" placeholder="请输入纳税人识别号" />
                </div>
            </div>
            <div class="item">
                <div :class="form.type==2?'item_l':'item_l_i'">开户银行</div>
                <div class="item_r">
                    <van-field v-model="form.bank" :placeholder="form.type==2?'必填':'选填'"/>
                </div>
            </div>
            <div class="item">
                <div :class="form.type==2?'item_l':'item_l_i'">银行卡号</div>
                <div class="item_r">
                    <van-field v-model="form.account" :placeholder="form.type==2?'必填':'选填'" />
                </div>
            </div>
            <div class="item">
                <div :class="form.type==2?'item_l':'item_l_i'">企业电话</div>
                <div class="item_r">
                    <van-field v-model="form.phone" :placeholder="form.type==2?'必填':'选填'" />
                </div>
            </div>
            <div class="item">
                <div :class="form.type==2?'item_l':'item_l_i'">企业地址</div>
                <div class="item_r">
                    <van-field v-model="form.address" :placeholder="form.type==2?'必填':'选填'" />
                </div>
            </div>
        </div>
        <div class="item" v-if="form.type==1">
            <div class="item_l_i">电子邮箱</div>
            <div class="item_r">
                <van-field v-model="form.email" placeholder="选填" />
            </div>
        </div>
        <div v-if="form.type==2">
            <div class="item" >
                <div class="item_l">领取方式</div>
                <div class="item_r">
                    <van-radio-group style="margin-left:10px" v-model="form.sendType" direction="horizontal">
                        <van-radio :name="1" checked-color="#d34444">自提</van-radio>
                        <van-radio :name="2" checked-color="#d34444">邮寄</van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="item" v-if="form.sendType==2">
                <div class="item_l_i">收件信息</div>
                <div class="item_r">
                    <van-field v-model="selectAddress.address" readonly />
                </div>
                <div class="item_r_select" @click="selectAddressAction">
                    请选择
                </div>
            </div>
        </div>
        <div class="item">
            <div class="item_l_i">备注</div>
            <div class="item_r">
                <van-field v-model="form.remark" placeholder="选填" />
            </div>
        </div>
        <div style="margin-top:0.5rem">
            <div class="invoice_attention">发票须知:</div>
            <div class="invoice_attention">1.发票金额为实际支付金额，不包含优惠券、礼品卡等。</div>
            <div class="invoice_attention">2.电子发票可以在参观完成后，在园区门票订单中查看和下载。</div>
            <div class="invoice_attention">3.电子发票将在1-3天内开出，如果填写邮箱还将发送到您的邮箱中。</div>
        </div>
        
    </div>
    <div class="action_wrap">
        <div class="action" @click="applyInvoice">保存</div>
    </div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			order_sn: this.$route.query.order_sn, // 订单号
            form: {
                type: 1,
                nameType: 1,
                tel: null,
                company: '',
                shuihao: '',
                address: '',
                phone: '',
                bank: '',
                account: '',
                remark: '',
                sendType: 1
            },
            selectInvoice: null,
            selectAddress: {
                address: null
            }
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '订单详情',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }
    },
    activated: function () {
        var invoice = this.$store.getters.select_invoice
        console.log('mounted:invoice:',invoice)
        if (this.order_sn != this.$route.query.order_sn) {
            this.order_sn = this.$route.query.order_sn
            this.form = {
                type: 1,
                nameType: 1,
                tel: null,
                company: '',
                shuihao: '',
                address: '',
                phone: '',
                bank: '',
                account: '',
                remark: '',
                sendType: 1
            },
            this.selectInvoice = null,
            this.selectAddress = {
                address: null
            }
        } else {
            if (invoice && invoice != undefined && invoice != '') {
                var selectInvoice = JSON.parse(this.$store.getters.select_invoice)
                console.log('selectInvoice=======', selectInvoice)
                if (selectInvoice) {
                    this.selectInvoice = selectInvoice
                    this.form.company = selectInvoice.company
                    this.form.shuihao = selectInvoice.shuihao
                    this.form.address = selectInvoice.address
                    this.form.phone = selectInvoice.phone
                    this.form.bank = selectInvoice.bank
                    this.form.account = selectInvoice.account
                }
                this.$store.commit('REMOVEINVOICE');
            } 
            var address = this.$store.getters.select_address
            if (address && address != undefined && address != '') {
                var selectAddress = JSON.parse(this.$store.getters.select_address)
                console.log('selectAddress=======', selectAddress)
                if (selectAddress) {
                    this.selectAddress = selectAddress
                }
                this.$store.commit('REMOVEADDRESS');
            }
        }
    },
	mounted() {
	},
    methods: {
        selectAddressAction() {
            // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //     var params = {
            //         'data': {
            //             'url': this.$publicData.clientUrl + '/user/adress?canSelect=1&addressId=' + (this.selectAddress&&this.selectAddress.address_id?this.selectAddress.address_id:'')
            //         }
            //     }
            //     this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //     })
            // } else {
                this.$store.commit('REMOVEADDRESS');
                this.$router.push({
                    path: '/user/adress',
                    query: {
                        canSelect: 1,
                        addressId: (this.selectAddress && this.selectAddress.address_id) ? this.selectAddress.address_id : ''
                    }
                })
            // }
        },
        selectInvoiceAction() {
            // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //     var params = {
            //         'data': {
            //             'url': this.$publicData.clientUrl + '/user/invoice?canSelect=1&invoiceId=' + (this.selectInvoice&&this.selectInvoice.invoice_id?this.selectInvoice.invoice_id:'')
            //         }
            //     }
            //     this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //     })
            // } else {
                this.$router.push({
                    path: '/user/invoice',
                    query: {
                        canSelect: 1,
                        invoiceId: (this.selectInvoice && this.selectInvoice.invoice_id) ? this.selectInvoice.invoice_id : ''
                    }
                })
            // }
        },
        applyInvoice() {
            var that = this
            var params = {}
            var form = this.form
            params.type = form.type
            if (form.type == 1) { // 电子发票
                params.nameType = form.nameType
                if (form.nameType == 1) { // 个人发票
                    if (form.tel == null || form.tel == undefined || form.tel == '') {
                        Toast('请输入联系人手机号')
                        return
                    }
                    params.company = '个人'
                    params.phone = form.tel
                } else { // 企业
                    if (form.company == null || form.company == undefined || form.company == '') {
                        Toast('请输入企业名称')
                        return
                    }
                    if (form.shuihao == null || form.shuihao == undefined || form.shuihao == '') {
                        Toast('请输入纳税人识别号')
                        return
                    }
                    params.company = form.company
                    params.shuihao = form.shuihao
                    params.address = form.address
                    params.phone = form.phone
                    params.bank = form.bank
                    params.account = form.account
                }
                params.email = form.email
            } else { // 纸质发票
                if (form.company == null || form.company == undefined || form.company == '') {
                    Toast('请输入企业名称')
                    return
                }
                if (form.shuihao == null || form.shuihao == undefined || form.shuihao == '') {
                    Toast('请输入纳税人识别号')
                    return
                }
                if (form.bank == null || form.bank == undefined || form.bank == '') {
                    Toast('请输入开户银行')
                    return
                }
                if (form.account == null || form.account == undefined || form.account == '') {
                    Toast('请输入银行卡号')
                    return
                }
                if (form.phone == null || form.phone == undefined || form.phone == '') {
                    Toast('请输入企业电话')
                    return
                }
                if (form.address == null || form.address == undefined || form.address == '') {
                    Toast('请输入企业地址')
                    return
                }
                if (form.sendType == 2) { // 邮寄
                    if (this.selectAddress == null || this.selectAddress.address == null || this.selectAddress.address == undefined || this.selectAddress.address == '') {
                        Toast('请选择收件地址')
                        return
                    }
                }
                params.company = form.company
                params.shuihao = form.shuihao
                params.address = form.address
                params.phone = form.phone
                params.bank = form.bank
                params.account = form.account
                if (form.sendType == 2) {
                    params.post_address = this.selectAddress.address
                    params.post_user = this.selectAddress.address_person
                    params.post_phone = this.selectAddress.address_phone
                }
                
                // params.sendAddress = this.selectAddress.address
            }
            params.order_num = this.order_sn
            params.mark = form.remark
            params.token = this.token
            that.$api.smartpark.applyInvoice(params).then(res=>{
				if(res.code == 200){
                    Toast('申请成功')
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //返回上级页面
                        var params = {'data':{}}
                        that.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        setTimeout(() => {
                            that.$router.back()
                        }, 2000);
                        
                    }
				}
			})
            
        }
		
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
